import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["flex", "flexShrink", "flexBasis", "flexGrow", "alignSelf"];
var extractFlexItemProps = function extractFlexItemProps(props) {
  var flex = props.flex,
    flexShrink = props.flexShrink,
    flexBasis = props.flexBasis,
    flexGrow = props.flexGrow,
    alignSelf = props.alignSelf,
    rest = _objectWithoutProperties(props, _excluded);
  var flexItemProps = {
    flex: flex,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    flexGrow: flexGrow,
    alignSelf: alignSelf
  };
  return {
    flexItemProps: flexItemProps,
    rest: rest
  };
};

export { extractFlexItemProps };
//# sourceMappingURL=Props.js.map
